// import request from '@/utils/request';

// let permissions = [];
// let inited = false;

// let OperatorCache = {
//   info: {},
//   inited() {
//     return inited;
//   },
//   init(callback) {
//     if (inited) {
//       callback();
//     } else {
//       request
//         .post('/Base_Manage/Home/GetOperatorInfo')
//         .then((resJson) => {
//           if (resJson.Data) {
//             this.info = resJson.Data.UserInfo;
//             permissions = resJson.Data.Permissions;
//             console.log('permissions1', permissions);

//             inited = true;
//             callback();
//           }
//         })
//         .catch((error) => {
//           console.error('获取操作员信息失败:', error);
//         });
//     }
//   },
//   hasPermission(thePermission) {
//     console.log('permissions2', permissions);

//     return permissions.includes(thePermission);
//   },
//   clear() {
//     inited = false;
//     permissions = [];
//     this.info = {};
//   },
//   // 添加一个方法用于获取权限列表
//   getPermissions() {
//     return permissions;
//   },
// };

// export default {
//   install(app) {
//     app.config.globalProperties.$op = OperatorCache;
//     app.config.globalProperties.hasPerm = OperatorCache.hasPermission;
//   },
// };

// 测试
import request from '@/utils/request';

let permissions = [];
let inited = false;
let isLoading = false; // 添加 isLoading 标志位

let OperatorCache = {
  info: {},
  inited() {
    return inited;
  },
  init(callback) {
    if (inited) {
      callback();
    } else {
      isLoading = true; // 开始加载，设置 isLoading 为 true
      request
        .post('/Base_Manage/Home/GetOperatorInfo')
        .then((resJson) => {
          if (resJson.Data) {
            this.info = resJson.Data.UserInfo;
            permissions = resJson.Data.Permissions;
            inited = true;
            isLoading = false; // 加载完成，设置 isLoading 为 false
            callback();
          }
        })
        .catch((error) => {
          console.error('获取操作员信息失败:', error);
          isLoading = false; // 加载失败，设置 isLoading 为 false
        });
    }
  },

  hasPermission(thePermission) {
    if (isLoading) {
      // console.log('权限数据正在加载中，暂时无法判断');
      return false; // 加载中，返回 false
    }
    if (permissions.length === 0) {
      // 如果 permissions 为空，重新初始化数据
      OperatorCache.init(() => {
        // console.log('重新初始化数据后，再次检查权限');
        OperatorCache.hasPermission(thePermission);
      });
      return false;
    }
    console.log(permissions.includes(thePermission));
    return permissions.includes(thePermission);
  },
  clear() {
    inited = false;
    permissions = [];
    this.info = {};
  },
  // 添加一个方法用于获取权限列表
  getPermissions() {
    return permissions;
  },
};

export default {
  install(app) {
    app.config.globalProperties.$op = OperatorCache;
    app.config.globalProperties.hasPerm = OperatorCache.hasPermission;
  },
};
